import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilePlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M10.504.75c.038 0 .075.003.111.009L10.5.75c.045 0 .089.004.132.012.03.005.06.012.088.02l.034.012c.023.008.046.018.068.028l.036.019c.02.01.037.021.055.033.013.009.026.017.038.027l.007.005.072.064 4.5 4.5c.025.025.048.051.07.08l-.07-.08c.036.036.068.075.096.117.012.018.023.036.033.055l.019.037c.01.021.02.044.028.067l.011.035c.022.069.033.142.033.219l-.001-.04.001.04v9c0 1.243-1.007 2.25-2.25 2.25h-9c-1.243 0-2.25-1.007-2.25-2.25V3C2.25 1.757 3.257.75 4.5.75zm-.755 1.5H4.5c-.414 0-.75.336-.75.75v12c0 .414.336.75.75.75h9c.414 0 .75-.336.75-.75V6.75H10.5c-.38 0-.693-.282-.743-.648L9.75 6l-.001-3.75zM9 8.25c.414 0 .75.336.75.75v1.5h1.5c.38 0 .693.282.743.648l.007.102c0 .414-.336.75-.75.75h-1.5v1.5c0 .38-.282.693-.648.743L9 14.25c-.414 0-.75-.336-.75-.75V12h-1.5c-.38 0-.693-.282-.743-.648L6 11.25c0-.414.336-.75.75-.75h1.5V9c0-.38.282-.693.648-.743zm2.249-4.94l.001 1.94h1.94l-1.941-1.94z"
	})
});
export default SvgFilePlus;
